import { useCallback, useContext } from "react";

import { MaskedInput } from "~/components/TextInput";
import { setCorporalEvaluationImageIndex } from "~/modules/corporalEvaluation/services";
import { patchEvaluationAtom } from "~/modules/evalutation/services";
import { studentEvaluationDemoContext } from "~/pages/authenticated/personalTrainer/studentEvaluationDemo";

import { Mean } from "./Mean";

export const AbdominalInput: React.FC = () => {
	const { data } = useContext(studentEvaluationDemoContext);

	const handleUpdateField = useCallback(
		(index: number, value: number) => {
			const newArr = data ? data.abdominal : [];
			newArr[index] = value;
			patchEvaluationAtom({ abdominal: newArr });
		},
		[data],
	);

	const handleFocus = useCallback(() => {
		setCorporalEvaluationImageIndex(2);
	}, []);

	return (
		<>
			<div className="whitespace-nowrap font-bold xl:font-normal">
				Abdominal (mm) &nbsp;
			</div>
			{data?.abdominal.map((val, index) => (
				<div key={`abdominal-${index}`}>
					<p className="block xl:hidden mb-2">Medida {index + 1}</p>
					<MaskedInput
						value={val}
						placeholder="0"
						mask="float"
						inputMode="decimal"
						onFocus={handleFocus}
						onChange={(v) => handleUpdateField(index, v)}
					/>
				</div>
			))}
			<div>
				<p className="block xl:hidden mb-2">Média</p>
				<Mean field="abdominal" />
			</div>
		</>
	);
};
